import { ModelBase } from '@framework/models/base/base.model';

export class LogoutOutputApiModel extends ModelBase {
    constructor(init?: Partial<LogoutOutputApiModel>){
        super(init);
        Object.assign(this, init);
    }
}